import { ICustomPushNotification } from '@api/models/notification.models';
import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

interface UserNotificationPayload {
    userIds: string[];
    title: string;
    message: string;
}
export const getAllNotification = async () => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/push-notifications`
    );
    return data as ICustomPushNotification[];
};

export const sendClientNotification = async (payload: any) => {
    const { data } = await http.post(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/push-notifications/send`,
        payload
    );
};
export const sendUserNotification = async (clientId: string, payload: UserNotificationPayload) => {
    const { data } = await http.post(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/push-notifications/clients/${clientId}/send`,
        payload
    );
};
